import { uuidv7 } from "uuidv7";
export const sessionID = uuidv7() + '-' + Date.now()
